document.addEventListener('DOMContentLoaded', () => {
    const faqQuestions = document.querySelectorAll('.pdp-ingredients .faq-item');
    const faqSidebars = document.querySelectorAll('.pdp-ingredients .faq-sidebar');
    const faqButtons = document.querySelectorAll('.pdp-ingredients .faq-buttons button');
    const pdpIngredientsSection = document.querySelector('.pdp-ingredients');

    if (!pdpIngredientsSection || faqQuestions.length === 0 || faqSidebars.length === 0) return;

    let currentIndex = 0;
    let intervalId;

    function hideAllSidebars() {
        faqSidebars.forEach((sidebar) => (sidebar.style.display = 'none'));
    }

    function removeActiveClassFromQuestions() {
        faqQuestions.forEach((question) => question.classList.remove('active'));
    }

    function removeActiveClassFromButtons() {
        faqButtons.forEach((button) => button.classList.remove('active'));
    }

    function toggleContent(sidebar, buttonType) {
        const images = sidebar.querySelectorAll('.faq-image-section img');
        const ingredientImage = images[0];
        const skinImage = images[1];
        const answer1 = sidebar.querySelector('.answer1');
        const answer2 = sidebar.querySelector('.answer2');

        if (ingredientImage && skinImage && answer1 && answer2) {
            ingredientImage.addEventListener('load', () => {
                if (buttonType === 'ingredientScience') {
                    ingredientImage.style.display = 'block';
                    skinImage.style.display = 'none';
                    answer1.style.display = 'block';
                    answer2.style.display = 'none';
                }
            });

            skinImage.addEventListener('load', () => {
                if (buttonType === 'skinScience') {
                    ingredientImage.style.display = 'none';
                    skinImage.style.display = 'block';
                    answer1.style.display = 'none';
                    answer2.style.display = 'block';
                }
            });

            if (buttonType === 'ingredientScience') {
                ingredientImage.style.display = 'block';
                skinImage.style.display = 'none';
                answer1.style.display = 'block';
                answer2.style.display = 'none';
            } else if (buttonType === 'skinScience') {
                ingredientImage.style.display = 'none';
                skinImage.style.display = 'block';
                answer1.style.display = 'none';
                answer2.style.display = 'block';
            }
            return;
        }
        console.error('One or more elements (images or answers) not found');
    }

    function showSidebarForCurrentIndex(index) {
        removeActiveClassFromQuestions();

        const currentQuestion = faqQuestions[index];
        currentQuestion.classList.add('active');

        hideAllSidebars();

        const topic = currentQuestion.getAttribute('data-topic').replace('faq-', '');
        const selectedSidebar = document.querySelector(`#faq-${topic}`);
        if (selectedSidebar) {
            selectedSidebar.style.display = 'flex';
            removeActiveClassFromButtons();

            const defaultButton = selectedSidebar.querySelector('button[data-topic="ingredientScience"]');
            if (defaultButton) {
                toggleContent(selectedSidebar, 'ingredientScience');
                defaultButton.classList.add('active');
            }
            return;
        }
        console.error(`Sidebar for FAQ with data-topic faq-${topic} not found`);
    }

    function startAutoSwitching() {
        clearInterval(intervalId);

        intervalId = setInterval(() => {
            currentIndex = (currentIndex + 1) % faqQuestions.length;
            showSidebarForCurrentIndex(currentIndex);
        }, 10_000);
    }

    function stopAutoSwitching() {
        clearInterval(intervalId);
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    startAutoSwitching();
                } else {
                    stopAutoSwitching();
                }
            });
        },
        { threshold: 0.5 }
    );

    observer.observe(pdpIngredientsSection);

    showSidebarForCurrentIndex(currentIndex);

    faqQuestions.forEach((question, index) => {
        question.addEventListener('click', () => {
            console.log('question');
            currentIndex = index;
            showSidebarForCurrentIndex(currentIndex);
            startAutoSwitching();
        });
    });

    faqButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const buttonType = button.getAttribute('data-topic');

            removeActiveClassFromButtons();

            button.classList.add('active');

            const activeSidebar = document.querySelector('.faq-sidebar:not([style*="display: none"])');
            if (activeSidebar) {
                toggleContent(activeSidebar, buttonType);
            }
        });
    });
});